import type { ExperimentConfig } from '@seek/candidate-feature-flag';

export const experimentsToFetch: ExperimentConfig[] = [];
